const config = {
  apiKey: "AIzaSyDWUVMbotSE5DcJ6CyZm5Jnyuxcu8cBSdw",
  authDomain: "ds-latam.firebaseapp.com",
  projectId: "ds-latam",
  storageBucket: "ds-latam.firebasestorage.app",
  messagingSenderId: "1016828853433",
  appId: "1:1016828853433:web:47b73b03f724c386feaf68",
  measurementId: "G-KSM0RKLPZG",
};

export default config;
